<template>
    <BaseModal
        ref="modal"
        size="md"
        modal-class="baseModal"
        footer-class="modalFooter"
        hide-header
        centered
        @submit="submit"
        @cancel="cancel"
    >
        <template #default>
            <h1>{{ $t('affect_pricing_title') }}</h1>
            <div>
                <span
                    >{{ $t('Adding a business unit will increase your') }}
                    {{
                        quantityChange.recurring_interval === 'year'
                            ? $t('yearly payment by')
                            : $t('monthly payment by')
                    }}
                    {{ quantityChange.recurring_amount_change }}
                    <span class="text-uppercase">{{ quantityChange.currency }}</span> {{ $t('VAT') }}.
                </span>
                <strong
                    >{{ $t('Please note you will be charged') }} {{ quantityChange.amount_charged_now }}
                    {{ $t(quantityChange.currency).toUpperCase() }}
                    {{ $t('VAT today for the period up to your next billing date') }}.</strong
                >
            </div>
        </template>

        <template #modal-footer="{ cancel, submit }">
            <span>
                <div class="text-center d-flex align-items-center justify-content-center">
                    <button
                        class="btn btn-outline-primary"
                        @click="cancel"
                    >
                        {{ $t('Cancel') }}
                    </button>
                    <button
                        class="btn btn-primary"
                        @click="submit"
                    >
                        {{ $t('create') }}
                    </button>
                </div>
            </span>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '@components/BaseModal';
import { mapGetters } from 'vuex';

export default {
    name: 'AffectPricingNotificationModal',

    components: {
        BaseModal,
    },

    computed: {
        ...mapGetters({
            quantityChange: 'billing/quantityChange',
        }),
        mailto() {
            return `mailto:${process.env.SUPPORT_EMAIL}`;
        },
        preferredCurrency() {
            return this.$store.getters.selectedCompany?.company?.preferred_currency?.iso3 || 'EUR';
        },
    },

    mounted() {
        this.$root.$on('affect-pricing', async () => {
            if (!this.quantityChange) {
                await this.$store.dispatch('billing/getQuantityChangePreview', 1);
            }
            this.$refs.modal.show();
        });
    },

    beforeDestroy() {
        this.$root.$off('affect-pricing');
    },

    methods: {
        submit() {
            this.$root.$emit('affect-pricing-click', true);
            this.$refs.modal.hide();
        },
        cancel() {
            this.$root.$emit('affect-pricing-click', false);
            this.$refs.modal.hide();
        },
    },
};
</script>
